var req = require("!!E:\\projects\\terminus-sync-config\\node_modules\\pug-loader\\index.js!E:\\projects\\terminus-sync-config\\src\\components\\SettingsTab.component.pug");
module.exports = (req['default'] || req).apply(req, [])